import { KeyboardEvent, ReactElement } from "react";
import Modal from "@ingka/modal";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/modal/dist/style.css";
import "@ingka/focus/dist/style.css";
import "@ingka/text/dist/style.css";

interface FixaModalProps {
  children: ReactElement[] | ReactElement;
  handleCloseBtn: () => void;
  visible?: boolean;
  className?: string;
  keepContentMounted?: boolean;
  focusLockProps?: { locked: boolean };
  onModalOpened?: (e: AnimationEvent) => void;
  escapable?: boolean;
  onKeyDown?: (e: KeyboardEvent) => void;
  "data-testid"?: string | undefined;
}

export const FixaModal = (props: FixaModalProps) => {
  const { children, ...rest } = props;
  return <Modal {...rest}>{children}</Modal>;
};
